"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Base exception class that can be inherited from.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
 */
var BaseException = function BaseException(message) {
  _classCallCheck(this, BaseException);

  this.message = message;

  this.name = this.constructor.name;
  this.stack = new Error().stack;
};

BaseException.prototype = Object.create(Error.prototype);
BaseException.prototype.constructor = BaseException;

/*
 * LOADER EXCEPTIONS
 */

var LoaderContentTypeError = exports.LoaderContentTypeError = function (_BaseException) {
  _inherits(LoaderContentTypeError, _BaseException);

  function LoaderContentTypeError() {
    _classCallCheck(this, LoaderContentTypeError);

    return _possibleConstructorReturn(this, (LoaderContentTypeError.__proto__ || Object.getPrototypeOf(LoaderContentTypeError)).apply(this, arguments));
  }

  return LoaderContentTypeError;
}(BaseException);

/*
 * MODEL EXCEPTIONS
 */


var ModelNameNotDefinedError = exports.ModelNameNotDefinedError = function (_BaseException2) {
  _inherits(ModelNameNotDefinedError, _BaseException2);

  function ModelNameNotDefinedError() {
    _classCallCheck(this, ModelNameNotDefinedError);

    return _possibleConstructorReturn(this, (ModelNameNotDefinedError.__proto__ || Object.getPrototypeOf(ModelNameNotDefinedError)).apply(this, arguments));
  }

  return ModelNameNotDefinedError;
}(BaseException);

var ModelSchemaNotDefinedError = exports.ModelSchemaNotDefinedError = function (_BaseException3) {
  _inherits(ModelSchemaNotDefinedError, _BaseException3);

  function ModelSchemaNotDefinedError() {
    _classCallCheck(this, ModelSchemaNotDefinedError);

    return _possibleConstructorReturn(this, (ModelSchemaNotDefinedError.__proto__ || Object.getPrototypeOf(ModelSchemaNotDefinedError)).apply(this, arguments));
  }

  return ModelSchemaNotDefinedError;
}(BaseException);

var ModelUniqueKeyNotDefinedError = exports.ModelUniqueKeyNotDefinedError = function (_BaseException4) {
  _inherits(ModelUniqueKeyNotDefinedError, _BaseException4);

  function ModelUniqueKeyNotDefinedError() {
    _classCallCheck(this, ModelUniqueKeyNotDefinedError);

    return _possibleConstructorReturn(this, (ModelUniqueKeyNotDefinedError.__proto__ || Object.getPrototypeOf(ModelUniqueKeyNotDefinedError)).apply(this, arguments));
  }

  return ModelUniqueKeyNotDefinedError;
}(BaseException);

var ModelMutateIsNotStandaloneError = exports.ModelMutateIsNotStandaloneError = function (_BaseException5) {
  _inherits(ModelMutateIsNotStandaloneError, _BaseException5);

  function ModelMutateIsNotStandaloneError() {
    _classCallCheck(this, ModelMutateIsNotStandaloneError);

    return _possibleConstructorReturn(this, (ModelMutateIsNotStandaloneError.__proto__ || Object.getPrototypeOf(ModelMutateIsNotStandaloneError)).apply(this, arguments));
  }

  return ModelMutateIsNotStandaloneError;
}(BaseException);

var ModelMutateNotSupported = exports.ModelMutateNotSupported = function (_BaseException6) {
  _inherits(ModelMutateNotSupported, _BaseException6);

  function ModelMutateNotSupported() {
    _classCallCheck(this, ModelMutateNotSupported);

    return _possibleConstructorReturn(this, (ModelMutateNotSupported.__proto__ || Object.getPrototypeOf(ModelMutateNotSupported)).apply(this, arguments));
  }

  return ModelMutateNotSupported;
}(BaseException);

var ModelKeyFilterEmpty = exports.ModelKeyFilterEmpty = function (_BaseException7) {
  _inherits(ModelKeyFilterEmpty, _BaseException7);

  function ModelKeyFilterEmpty() {
    _classCallCheck(this, ModelKeyFilterEmpty);

    return _possibleConstructorReturn(this, (ModelKeyFilterEmpty.__proto__ || Object.getPrototypeOf(ModelKeyFilterEmpty)).apply(this, arguments));
  }

  return ModelKeyFilterEmpty;
}(BaseException);

var ModelKeyFilterInvalid = exports.ModelKeyFilterInvalid = function (_BaseException8) {
  _inherits(ModelKeyFilterInvalid, _BaseException8);

  function ModelKeyFilterInvalid() {
    _classCallCheck(this, ModelKeyFilterInvalid);

    return _possibleConstructorReturn(this, (ModelKeyFilterInvalid.__proto__ || Object.getPrototypeOf(ModelKeyFilterInvalid)).apply(this, arguments));
  }

  return ModelKeyFilterInvalid;
}(BaseException);

var ModelGroupKeysNotDefinedError = exports.ModelGroupKeysNotDefinedError = function (_BaseException9) {
  _inherits(ModelGroupKeysNotDefinedError, _BaseException9);

  function ModelGroupKeysNotDefinedError() {
    _classCallCheck(this, ModelGroupKeysNotDefinedError);

    return _possibleConstructorReturn(this, (ModelGroupKeysNotDefinedError.__proto__ || Object.getPrototypeOf(ModelGroupKeysNotDefinedError)).apply(this, arguments));
  }

  return ModelGroupKeysNotDefinedError;
}(BaseException);

/*
 * AUTH EXCEPTIONS
 */


var GetAuthenticationNotImplemented = exports.GetAuthenticationNotImplemented = function (_BaseException10) {
  _inherits(GetAuthenticationNotImplemented, _BaseException10);

  function GetAuthenticationNotImplemented() {
    _classCallCheck(this, GetAuthenticationNotImplemented);

    return _possibleConstructorReturn(this, (GetAuthenticationNotImplemented.__proto__ || Object.getPrototypeOf(GetAuthenticationNotImplemented)).apply(this, arguments));
  }

  return GetAuthenticationNotImplemented;
}(BaseException);

var CheckAuthenticationNotImplemented = exports.CheckAuthenticationNotImplemented = function (_BaseException11) {
  _inherits(CheckAuthenticationNotImplemented, _BaseException11);

  function CheckAuthenticationNotImplemented() {
    _classCallCheck(this, CheckAuthenticationNotImplemented);

    return _possibleConstructorReturn(this, (CheckAuthenticationNotImplemented.__proto__ || Object.getPrototypeOf(CheckAuthenticationNotImplemented)).apply(this, arguments));
  }

  return CheckAuthenticationNotImplemented;
}(BaseException);

var RequestAuthenticationNotImplemented = exports.RequestAuthenticationNotImplemented = function (_BaseException12) {
  _inherits(RequestAuthenticationNotImplemented, _BaseException12);

  function RequestAuthenticationNotImplemented() {
    _classCallCheck(this, RequestAuthenticationNotImplemented);

    return _possibleConstructorReturn(this, (RequestAuthenticationNotImplemented.__proto__ || Object.getPrototypeOf(RequestAuthenticationNotImplemented)).apply(this, arguments));
  }

  return RequestAuthenticationNotImplemented;
}(BaseException);

var ClearAuthenticationNotImplemented = exports.ClearAuthenticationNotImplemented = function (_BaseException13) {
  _inherits(ClearAuthenticationNotImplemented, _BaseException13);

  function ClearAuthenticationNotImplemented() {
    _classCallCheck(this, ClearAuthenticationNotImplemented);

    return _possibleConstructorReturn(this, (ClearAuthenticationNotImplemented.__proto__ || Object.getPrototypeOf(ClearAuthenticationNotImplemented)).apply(this, arguments));
  }

  return ClearAuthenticationNotImplemented;
}(BaseException);

var GetAuthenticationHeadersNotImplemented = exports.GetAuthenticationHeadersNotImplemented = function (_BaseException14) {
  _inherits(GetAuthenticationHeadersNotImplemented, _BaseException14);

  function GetAuthenticationHeadersNotImplemented() {
    _classCallCheck(this, GetAuthenticationHeadersNotImplemented);

    return _possibleConstructorReturn(this, (GetAuthenticationHeadersNotImplemented.__proto__ || Object.getPrototypeOf(GetAuthenticationHeadersNotImplemented)).apply(this, arguments));
  }

  return GetAuthenticationHeadersNotImplemented;
}(BaseException);

/*
 * NOTIFIER EXCEPTIONS
 */


var OnStartNotImplemented = exports.OnStartNotImplemented = function (_BaseException15) {
  _inherits(OnStartNotImplemented, _BaseException15);

  function OnStartNotImplemented() {
    _classCallCheck(this, OnStartNotImplemented);

    return _possibleConstructorReturn(this, (OnStartNotImplemented.__proto__ || Object.getPrototypeOf(OnStartNotImplemented)).apply(this, arguments));
  }

  return OnStartNotImplemented;
}(BaseException);

var OnStopNotImplemented = exports.OnStopNotImplemented = function (_BaseException16) {
  _inherits(OnStopNotImplemented, _BaseException16);

  function OnStopNotImplemented() {
    _classCallCheck(this, OnStopNotImplemented);

    return _possibleConstructorReturn(this, (OnStopNotImplemented.__proto__ || Object.getPrototypeOf(OnStopNotImplemented)).apply(this, arguments));
  }

  return OnStopNotImplemented;
}(BaseException);

var OnLoginNotImplemented = exports.OnLoginNotImplemented = function (_BaseException17) {
  _inherits(OnLoginNotImplemented, _BaseException17);

  function OnLoginNotImplemented() {
    _classCallCheck(this, OnLoginNotImplemented);

    return _possibleConstructorReturn(this, (OnLoginNotImplemented.__proto__ || Object.getPrototypeOf(OnLoginNotImplemented)).apply(this, arguments));
  }

  return OnLoginNotImplemented;
}(BaseException);

var OnLogoutNotImplemented = exports.OnLogoutNotImplemented = function (_BaseException18) {
  _inherits(OnLogoutNotImplemented, _BaseException18);

  function OnLogoutNotImplemented() {
    _classCallCheck(this, OnLogoutNotImplemented);

    return _possibleConstructorReturn(this, (OnLogoutNotImplemented.__proto__ || Object.getPrototypeOf(OnLogoutNotImplemented)).apply(this, arguments));
  }

  return OnLogoutNotImplemented;
}(BaseException);

var OnSubscribeNotImplemented = exports.OnSubscribeNotImplemented = function (_BaseException19) {
  _inherits(OnSubscribeNotImplemented, _BaseException19);

  function OnSubscribeNotImplemented() {
    _classCallCheck(this, OnSubscribeNotImplemented);

    return _possibleConstructorReturn(this, (OnSubscribeNotImplemented.__proto__ || Object.getPrototypeOf(OnSubscribeNotImplemented)).apply(this, arguments));
  }

  return OnSubscribeNotImplemented;
}(BaseException);

/*
 * UTIL EXCEPTIONS
 */


var NotAnArray = exports.NotAnArray = function (_BaseException20) {
  _inherits(NotAnArray, _BaseException20);

  function NotAnArray() {
    _classCallCheck(this, NotAnArray);

    return _possibleConstructorReturn(this, (NotAnArray.__proto__ || Object.getPrototypeOf(NotAnArray)).apply(this, arguments));
  }

  return NotAnArray;
}(BaseException);

var NotAMap = exports.NotAMap = function (_BaseException21) {
  _inherits(NotAMap, _BaseException21);

  function NotAMap() {
    _classCallCheck(this, NotAMap);

    return _possibleConstructorReturn(this, (NotAMap.__proto__ || Object.getPrototypeOf(NotAMap)).apply(this, arguments));
  }

  return NotAMap;
}(BaseException);